import { DefaultRootState } from 'react-redux';

const getTermsOfUseLink = (lang: 'en' | 'tr' | 'ru') => {
    switch (lang) {
        case 'tr':
            return 'https://yandex.com.tr/legal/telemost_termsofuse';
        case 'en':
            return `https://yandex.ru/legal/telemost_termsofuse?lang=${lang}`;
        default:
            return 'https://yandex.ru/legal/telemost_termsofuse';
    }
};

// Требования здесь:
// https://st.yandex-team.ru/CHEMODAN-73346
export const getExternalLinks = (state: DefaultRootState) => {
    let lang = state.config.appLang || 'ru';

    if (lang === 'uk') {
        lang = 'ru';
    }

    return {
        help: `https://yandex.ru/support/telemost?lang=${lang}`,
        helpNoAccess: `https://yandex.ru/support/telemost/settings.html?lang=${lang}#access-cam-mic`,
        helpSharingAccess: `https://yandex.ru/support/telemost/settings.html?lang=${lang}#access-sharing`,
        termsOfUse: getTermsOfUseLink(lang),
    };
};

export const getSocialLinks = (state: DefaultRootState) => {
    const uriEncoded = encodeURIComponent(state.call.conference.config?.uri || '');

    return {
        telegram: `https://t.me/share/url?url=${uriEncoded}`,
        whatsapp: `https://api.whatsapp.com/send?text=${uriEncoded}`,
        messenger: `${state.config.yaServices.q}?text=${uriEncoded}#/forward`,
        slack: 'https://slack.com',
    };
};
